import { useState, useEffect } from 'react';
import { supabase } from '../integrations/supabase/client';
import { User } from '@supabase/supabase-js';
import React from 'react';

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};

export function useAuth() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Initial session fetch
    supabase.auth.getSession().then(({ data: { session }, error }) => {
      if (error) {
        console.error('[Auth] getSession error:', error);
      }
      setUser(session?.user ?? null);
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      console.log('[Auth] onAuthStateChange:', event, session?.user?.email);
      setUser(session?.user ?? null);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  const signIn = async (email: string, password: string) => {
    console.log('[Auth] signIn attempt for', email);
    const { error, data } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      console.error('[Auth] signIn error:', error);
      throw error;
    }
    console.log('[Auth] signIn success for', data.user?.email);
  };

  const signUp = async (email: string, password: string) => {
    console.log('[Auth] signUp attempt for', email);
    const { error, data } = await supabase.auth.signUp({ email, password });
    if (error) {
      console.error('[Auth] signUp error:', error);
      throw error;
    }
    console.log('[Auth] signUp success for', data.user?.email);
  };

  const signOut = async () => {
    console.log('[Auth] signOut attempt');
    const { error } = await supabase.auth.signOut();
    try {
      // Best-effort: clear any cached tokens
      localStorage.removeItem('supabase.auth.token');
      localStorage.removeItem('sb-' + (process.env.REACT_APP_SUPABASE_URL || '')); // namespace key (may not match but safe)
      sessionStorage.clear();
    } catch (e) {
      console.warn('[Auth] storage cleanup warning:', e);
    }
    if (error) {
      console.error('[Auth] signOut error:', error);
      throw error;
    }
    console.log('[Auth] signOut success');
    setUser(null);
  };

  const resetPassword = async (email: string) => {
    console.log('[Auth] resetPassword for', email);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin + '/auth',
    });
    if (error) {
      console.error('[Auth] resetPassword error:', error);
      throw error;
    }
  };

  return { user, loading, signIn, signUp, signOut, resetPassword };
}